import { StatusDesign } from "@components";

export const COLUMNS = [
  {
    accessor: "pos_code",
    Header: "POS Code",
  },
  {
    accessor: "pos_name",
    Header: "POS Name",
  },
  {
    accessor: "branch_code",
    Header: "Branch Code",
  },
  {
    accessor: "company_code",
    Header: "Company Code",
  }, 
  {
    accessor: "is_active",
    Header: "Status",
    width: 100,
    Cell: (data) => {
      const d = data?.row?.original; 
      return (<>
        {d.is_active ? 
          <div className='bg-[#f6ffed] border-[1px] border-[#b7eb8f] w-[100px] rounded-sm flex items-center justify-center'>
            <span className='text-xs text-[#389e0d] p-1'>Active</span>
          </div> 
          : 
          <div className='bg-[#fff1f0] border-[1px] border-[#ffa39e] w-[100px] rounded-sm flex items-center justify-center'>
            <span className='text-xs text-[#cf1322] p-1'>Inactive</span>
          </div>
          }
      </>) 
    },
  },
];